module.exports = __webpack_public_path__ + "assets/img/popup.7b61f180.png";